export default __webpack_public_path__ + "assets/png/fc7c9e8ca812d2c9e2378b1ed36f8aa6.png";